module.exports = __webpack_public_path__ + "static/10-5500e78eb3c3e0c7aef591eff7d68b84.jpg";